import { Component, Inject, Injectable, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';
import { MessageBusService } from 'src/app/core/services/message-bus.service';
import { PublicProfileService } from 'src/app/core/services/public-profile.service';
import { FileViewerDialogComponent } from 'src/app/shared/components/dialogs/file-viewer-dialog/file-viewer-dialog.component';
import { FileViewerDto, FileViewerItemDto, IDocumentProvider } from 'src/app/shared/components/file-viewer/file-viewer.component';
import { ComponentLookup } from 'src/app/shared/decorators/component-lookup.decorator';
import { IControlComponent } from 'src/app/shared/interfaces/control-component';
import { DialogData } from 'src/app/shared/models/dialog-data.model';
import { FormComponentData } from 'src/app/shared/models/people/form-control.model';
import { PublicProfileDetailType } from 'src/app/shared/models/people/profile-detail.model';
import { DocumentPublicProfile, PublicProfile } from 'src/app/shared/models/people/public-profile.model';
import { SystemDocument } from 'src/app/shared/models/process/document.model';


@Injectable()
export class PublicProfileDocumentProvider implements IDocumentProvider {
  publicProfileId : number;
  publicProfileDetailType: PublicProfileDetailType;
  
  constructor(
    private publicProfileService : PublicProfileService) {
  }

  getDocument(documentId: number) : Observable<SystemDocument> {
    return this.publicProfileService.getProfileDetailsDocument(this.publicProfileId, this.publicProfileDetailType, documentId);
  }
}


@Component({
  selector: 'app-profile-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./../../styles/public-profile.css', './gallery.component.css'],
  providers: [PublicProfileDocumentProvider],
  encapsulation: ViewEncapsulation.None
})
@ComponentLookup('ProfileGalleryComponent')
export class GalleryComponent implements OnInit, OnDestroy, IControlComponent  {
  
  data: FormComponentData;
  private ngUnsubscribe = new Subject();
  publicProfile: PublicProfile;
  profileImages: SystemDocument[];
  finishLoading: boolean = false;
  showMore: boolean = true;
  showMoreImages: boolean = false;
  showCard: boolean = true;

  constructor(
    protected messageBusService: MessageBusService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    public dialog: MatDialog,
    private publicProfileDocumentProvider: PublicProfileDocumentProvider,
    private baseService: BaseService,
    protected publicProfileService: PublicProfileService,
  ) {}

  ngOnInit(): void {
    this.messageBusService.onSendPublicProfile()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.publicProfile = message.publicProfile;
        
        this.publicProfileDocumentProvider.publicProfileId = this.publicProfile.idPerfilPublico;
        this.publicProfileDocumentProvider.publicProfileDetailType = PublicProfileDetailType.PhotoGallery;

        this.setShowCard();

        this.getDocuments();        
    });
    
    this.baseService.sendComponentFinishLoadingMessage(this.data);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setShowCard() {
    this.showCard = (this.publicProfile.fotosGaleria && this.publicProfile.fotosGaleria.length > 0);
  }  

  getDocuments() {
    if (!this.publicProfile.fotosGaleria || this.publicProfile.fotosGaleria.length == 0) {
      this.finishLoading = true;
      return;
    }

    this.publicProfileService.getProfileDetailsDocuments(this.publicProfile.idPerfilPublico, PublicProfileDetailType.PhotoGallery).subscribe(documents => {
      this.profileImages = documents;
      
      for(let i=0; i < documents.length; i++) {
        let doc = documents[i];
        let profileDoc = this.publicProfile.fotosGaleria.find(d => d.idObjetoDetalle == doc.id);

        if (profileDoc)
          profileDoc.ubicacionFoto = doc.url;
      }

      this.finishLoading = true;
    });
  }

  getImages() : DocumentPublicProfile[] {
    if (this.showMore) {
        return this.publicProfile.fotosGaleria;
    } 
    else {
        if (this.publicProfile.fotosGaleria && this.publicProfile.fotosGaleria.length > 4) {
            this.showMoreImages = true;

            return this.publicProfile.fotosGaleria.slice(0, 4);
        }

        this.showMoreImages = false;

        return this.publicProfile.fotosGaleria;
    }
  }

  imageTrackBy(index : number, item: DocumentPublicProfile):number{
    return item.id; 
  }

  onFileClick(item: DocumentPublicProfile) {
    let dialogData = new DialogData();
    let viewerDto = new FileViewerDto(); 
    
    viewerDto.selectedFileId = item.idObjetoDetalle? item.idObjetoDetalle : 0;
    viewerDto.files = this.getConsultationDocumentAsViewerItems(this.profileImages);    
    viewerDto.useExternalDocumentProvider = true;
    viewerDto.documentProvider = this.publicProfileDocumentProvider;

    dialogData.data = viewerDto;

    const dialogRef = this.dialog.open(FileViewerDialogComponent, {
      panelClass: 'file-viewer-dialog',
      data: dialogData
    });
  }

  getConsultationDocumentAsViewerItems(items: SystemDocument[]): FileViewerItemDto[] {
    let result = items.map(d => {
      let fileDto = new FileViewerItemDto();

      fileDto.fileId = d.id;
      fileDto.fileUrl = d.ubicacionWeb;
      fileDto.amazonBucketName = d.nombreBucketAmazonS3;
      fileDto.fileExtension = d.extension;
      fileDto.webUrl = d.ubicacionWeb;

      fileDto.createdAt = d.fecha;
      fileDto.title = d.nombre;
      fileDto.description = d.descripcion;

      return fileDto;
    });

    return result;
  }

}
